import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { HeaderService } from 'src/app/shared/services/header/header.service';
import { FlashMessageService } from 'src/app/shared/services/flash-message.service';
import { FileProcessingStatus } from 'src/app/modals/file-processing-status.modal';
import { FormStatusEnum } from 'src/app/shared/enum/form-status.enum';
import { HcPagination } from 'src/app/modals/hc-pagination.modal';
import { FileProcessingStatusEnum } from 'src/app/shared/enum/file-processing-status.enum';
import { UserMassUploadService } from '../services/user-mass-upload.service';
import { CurrentUserService } from 'src/app/core/services/current-user.service';
import { saveAs } from 'file-saver';
import { GoogleAnalyticsService } from 'src/app/shared/services/google-analytics/google-analytics.service';
@Component({
  selector: 'review-users',
  templateUrl: './review-users.component.html',
  styleUrls: ['./review-users.component.scss']
})
export class ReviewUsersComponent implements OnInit {

  constructor(public header: HeaderService,
    private cdRef: ChangeDetectorRef,
    private currentUserService: CurrentUserService,
    private _gaSvc: GoogleAnalyticsService,
    private _massUserService: UserMassUploadService,
    private _flashMessageService: FlashMessageService) { }

  public loading: boolean = true;
  public loadingData: boolean = false;
  public progressStats = new FileProcessingStatus();
  public selected: string = FormStatusEnum.INVALID;
  public validPageInfo = new HcPagination();
  public invalidPageInfo = new HcPagination();
  public FormStatusEnum = FormStatusEnum;
  public validUsers: any[] = [];
  public invalidUsers: any[] = [];
  public downloadLoading: boolean = false;

  ngOnInit() {
    this.header.headerTitle = "Supplier Mass Upload Review";
    this._getUsersTempData();
    this.progressStats.setTotal(this._massUserService.getTotalUsersCount());
  }

  /**
   * Refresh data based on nav menu
   * @param status
   */
  public changeNav(status: string) {
    this.selected = status;
    this.validPageInfo.reset();
    this.invalidPageInfo.reset();
    this._getUsersTempData();
  }

  /**
   * Refresh data on refresh page action
   */
  public refreshPage() {
    this._getUsersTempData();
  }

  /**
   * Get users from temporary collection in mongo
   */
  private _getUsersTempData() {
    this._gaSvc.register('Mass Upload User', `Displaying ${this.selected} orders.`, this.currentUserService.user.username);
    this.loadingData = true;
    this._massUserService
      .getUsers(this.selected === FormStatusEnum.VALID ? this.validPageInfo : this.invalidPageInfo, this.selected)
      .subscribe(result => {
        // If status is processing keep checking if loading is complete after every 500 milliseconds
        if (result['status'] === FileProcessingStatusEnum.PROCESSING) {
          // update processed count in UI
          this.progressStats.setProcessed(this.progressStats.getTotal() - Number(result['count']));
          setTimeout(this._getUsersTempData.bind(this), 500);
        } else if (result['status'] === FileProcessingStatusEnum.COMPLETED) {
          // if process is complete set valid/invalid users to render on UI
          if (this.selected === FormStatusEnum.VALID) {
            this.validUsers = result['data'];
            this.validPageInfo.setTotal(Number(result['total']));
          } else {
            this.invalidUsers= result['data'];
            this.invalidPageInfo.setTotal(Number(result['total']));
            this.cdRef.detectChanges();
          }

          this.loading = false;
          this.loadingData = false;
          this.cdRef.detectChanges();
        }
      }, () => {
        this._flashMessageService.updateMessage('Error while uploading users.');
      });
  }

    /**
   * Page change for invalid users
   * @param $event
   */
  public changeInvalidPage($event): void {
    this.invalidPageInfo.setPageIndex(Number($event['pageIndex']));
    this.invalidPageInfo.setPageSize(Number($event['pageSize']));
    this._getUsersTempData();
  }

  /**
   * Page change for valid users
   * @param $event
   */
  public changeValidPage($event): void {
    this.validPageInfo.setPageIndex(Number($event['pageIndex']));
    this.validPageInfo.setPageSize(Number($event['pageSize']));
    this._getUsersTempData();
  }

  /**
   * Save valid users to supplier collection from temp collection
   */
  public submitValidUsers(): void {
    this._gaSvc.register('Mass Upload User', 'Submitted valid orders.', this.currentUserService.user.username);
    this._massUserService.submitValidUsers().subscribe(result => {
      this.validUsers = [];
      this._flashMessageService.updateMessage(`Successfully submitted valid users.`, 3000, 'success');
      this._getUsersTempData();
    })
  }

  /**
   * Download invalid users to excel file
   */
  public downloadInvalidUsers(): void {
    this.downloadLoading = true;
    this._gaSvc.register('Mass Upload User', 'Downloaded Invalid Users', this.currentUserService.user.username);
    // To unpack the excel file from the route we use a npm package file-saver. It takes a blob object and saves it with the filename provided.
    this._massUserService.getDownloadInvalidUserLink().subscribe(blob => {
      saveAs(blob, 'Invalid_Users.xlsx')
      this.downloadLoading = false
    }, err => {
      this._flashMessageService.updateMessage(`Could not download invalid users, please try again later.`);
      this.downloadLoading = false
    });
  }

}
